import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
import mitt from "mitt"
import {showToast} from "vant";
import withdraw_type_1 from "@/assets/icons/withdraw/withdraw_type_1.png";
import withdraw_type_2 from "@/assets/icons/withdraw/withdraw_type_2.png";
import withdraw_type_3 from "@/assets/icons/withdraw/withdraw_type_3.png";
import withdraw_type_4 from "@/assets/icons/withdraw/withdraw_type_4.png";
import withdraw_type_5 from "@/assets/icons/withdraw/withdraw_type_5.png";
import withdraw_type_6 from "@/assets/icons/withdraw/withdraw_type_6.png";
import withdraw_type_7 from "@/assets/icons/withdraw/withdraw_type_7.png";
import withdraw_type_8 from "@/assets/icons/withdraw/withdraw_type_8.png";
import withdraw_type_9 from "@/assets/icons/withdraw/withdraw_type_9.png";
import withdraw_type_10 from "@/assets/icons/withdraw/withdraw_type_10.png";
import withdraw_type_11 from "@/assets/icons/withdraw/withdraw_type_11.png";
import withdraw_type_12 from "@/assets/icons/withdraw/withdraw_type_12.png";
import withdraw_type_13 from "@/assets/icons/withdraw/withdraw_type_13.png";
import withdraw_type_14 from "@/assets/icons/withdraw/withdraw_type_14.png";
import withdraw_type_15 from "@/assets/icons/withdraw/withdraw_type_15.png";
import withdraw_type_16 from "@/assets/icons/withdraw/withdraw_type_16.png";
import withdraw_type_17 from "@/assets/icons/withdraw/withdraw_type_17.png";

export const emitter = mitt();
export const kDebug = import.meta.env.MODE === 'development';
export const kRelease = import.meta.env.MODE !== 'development';

export function getQueryParam(name) {
    let queryString = '';

    // 1. 先拿到 query 字符串（支持标准和 hash 模式）
    if (window.location.search) {
        queryString = window.location.search.substring(1);
    } else if (window.location.hash.includes('?')) {
        queryString = window.location.hash.split('?')[1];
    }

    // 2. 先尝试用 URLSearchParams 解析
    let result = null;

    if (typeof URLSearchParams !== 'undefined') {
        try {
            const params = new URLSearchParams(queryString);
            result = params.get(name);
        } catch (e) {
            // 避免 URLSearchParams 报错导致程序终止
            result = null;
        }
    }

    // 3. 如果未解析到，降级走正则 fallback
    if (result === null) {
        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        const match = queryString.match(reg);
        result = match ? decodeURIComponent(match[2]) : null;
    }

    return result;
}


export function log(message) {
    if (kDebug) {
        window.vLog(message);
    }
}

const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

class HComFunctions {
    static instance;

    constructor() {
        if (HComFunctions.instance) {
            return HComFunctions.instance;
        }
        HComFunctions.instance = this;
    }
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
    //获取当日23:59:59点时间戳(秒)以及多少天以前的0点时间戳（秒）默认2天前
    getNowAndNDaysAgoStart(n = 2) {
        const now = new Date();
        // 今日 23:59:59
        const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        const nowSecs = Math.floor(todayEnd.getTime() / 1000);
        //n天前
        const nDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - n); // N天前 0 点
        const nDaysAgoSecs = Math.floor(nDaysAgo.getTime() / 1000); // 转为秒

        return {
            nowSecs,
            nDaysAgoSecs
        };
    }
    isHaveChinese(str) {
        for (let i = 0; i < str.length; i++) {
            const code = str.charCodeAt(i);
            if (code >= 0x4e00 && code <= 0x9fff) {
                return true;
            }
        }
        return false;
    }

    //保存上一次tab的选项目
    saveLastActiveTabType = 1;
    getSaveActiveTypeByName(name){
        for (let i = 0; i < this.withdrawTypeList.length; i++) {
            if (name === this.withdrawTypeList[i]["name"]) {
                return this.withdrawTypeList[i]["type"];
            }
        }
        return this.withdrawTypeList[0]["type"];
    }
    getSaveActiveNameByType(type){
        for (let i = 0; i < this.withdrawTypeList.length; i++) {
            if (type === this.withdrawTypeList[i]["type"]) {
                return this.withdrawTypeList[i]["name"];
            }
        }
        return this.withdrawTypeList[0]["name"];
    }
    withdrawTypeList = [
        {
            name: "银行卡",
            type: 1,
            icon: withdraw_type_1,
        },
        {
            name: "支付宝",
            type: 3,
            icon: withdraw_type_3,
        },
        {
            name: "微信",
            type: 4,
            icon: withdraw_type_4,
        },
        {
            name: "USDT",
            type: 2,
            icon: withdraw_type_2,
        },
        {
            name: "波币",
            type: 8,
            icon: withdraw_type_8,
        },
        {
            name: "NOPAY",
            type: 5,
            icon: withdraw_type_5,
        },
        {
            name: "GOPAY",
            type: 6,
            icon: withdraw_type_6,
        },
        {
            name: "EBPAY",
            type: 7,
            icon: withdraw_type_7,
        },
        {
            name: "K豆钱包",
            type: 9,
            icon: withdraw_type_9,
        },
        {
            name: "万币",
            type: 10,
            icon: withdraw_type_10,
        },
        {
            name: "钱能钱包",
            type: 11,
            icon: withdraw_type_11,
        },
        {
            name: "ABPAY",
            type: 12,
            icon: withdraw_type_12,
        },
        {
            name: "OKPAY",
            type: 13,
            icon: withdraw_type_13,
        },
        {
            name: "C币钱包",
            type: 14,
            icon: withdraw_type_14,
        },
        {
            name: "JD钱包",
            type: 15,
            icon: withdraw_type_15,
        },
        {
            name: "365PAY",
            type: 16,
            icon: withdraw_type_16,
        },
        {
            name: "红豆PAY",
            type: 17,
            icon: withdraw_type_17,
        },
    ];

    //从数组中直接删除元素
    removeObjByList(list,target){
        const index = list.indexOf(target)
        if (index !== -1) {
            list.splice(index, 1)
        }
    }


    // 复制到粘贴板
    copyClipboard(str,isShowToast = true){
        navigator.clipboard.writeText(str)
            .then(() => {
                if(isShowToast){
                    showToast("复制成功");
                }
            })
            .catch((err) => {
                showToast("复制失败");
            });
    }

    getDateByMillSecs(secs, type = 0) {// 秒
        const date = new Date(secs * 1000) // 转换为毫秒
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        if (type === 0) {//年-月-日
            return `${year}-${month}-${day}`
        } else if (type === 1) {//年-月-日 时:分:秒
            const hour = String(date.getHours()).padStart(2, '0')
            const min = String(date.getMinutes()).padStart(2, '0')
            const sec = String(date.getSeconds()).padStart(2, '0')
            return `${year}-${month}-${day} ${hour}:${min}:${sec}`
        }else if (type === 2) {//月-日 时:分:秒
            const hour = String(date.getHours()).padStart(2, '0')
            const min = String(date.getMinutes()).padStart(2, '0')
            const sec = String(date.getSeconds()).padStart(2, '0')
            return `${month}-${day} ${hour}:${min}:${sec}`
        }
    }

    launchUrl(url) {
        window.open(url, '_blank');
    }

    processWithDrawData(withDrawMap) {
        const targetWithDrawMap = withDrawMap ?? {
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
            "7": [],
            "8": [],
            "9": [],
            "10": [],
            "12": [], //ABPAY
            "13": [], //OKPAY
            "14": [], //C币钱包
            "15": [], //JD钱包
            "16": [], //365PAY
            "17": [], //红豆PAY
        };

        for (let i = 1; i <= 17; i++) {
            const key = String(i);
            if (targetWithDrawMap[key] == null) {
                targetWithDrawMap[key] = [];
            }
        }

        return targetWithDrawMap;
    }


    getMoneyValue(money, {saveCount = 2, bringDot = false} = {}) {
        const moneyNum = Number(money) / 100;

        if (bringDot) {
            const frontStr = Math.floor(Number(money) / 100000).toString();
            const lastMoney = Number(money) % 100000;

            if (moneyNum >= 1000) {
                return `${frontStr},${String(Math.floor(lastMoney / 100)).padStart(3, '0')}`;
            } else {
                return Math.round(moneyNum).toString();
            }
        } else {
            return moneyNum.toFixed(saveCount);
        }
    }

    getMainColor(cssName = "--ct-main-color") {
        return getComputedStyle(document.documentElement)
            .getPropertyValue(cssName)
            .trim();
    }

    getMainFontColor() {
        return getComputedStyle(document.documentElement)
            .getPropertyValue('--ct-main-font-color')
            .trim();
    }

//切换主题
    setTheme(themeClass) {
        document.documentElement.classList.add(themeClass);
    }s

    getTextStyle({
                     oneRow = false,
                     color = "",
                     addSize = 0,
                     marginTop = 0,
                     marginBottom = 0,
                     marginRight = 0,
                     marginLeft = 0,
                     textAlign = "normal",
                     fontWeight = "normal",
                     flex = undefined,  // 允许传递 undefined 或者 null
                     padding = 0,
                     textDecoration = "normal",
                 } = {}) {
        return {
            "color": color !== "" ? (color === "main" ? this.getMainColor() : color) : this.getMainFontColor(),
            "fontSize": (14 + addSize) + 'px',
            "marginBottom": marginBottom + 'px',
            "marginTop": marginTop + 'px',
            "marginRight": marginRight + 'px',
            "marginLeft": marginLeft + 'px',
            "padding": padding + 'px',
            "fontWeight": fontWeight,
            "flex": flex,
            "whiteSpace": oneRow ? 'nowrap' : 'pre-line',
            "overflow": oneRow ? 'hidden' : 'visible',
            "textOverflow": oneRow ? 'ellipsis' : 'clip',
            "textAlign": textAlign,
            "textDecoration": textDecoration,
        };
    }

    getDeviceType() {
        const ua = navigator.userAgent.toLowerCase();
        if (/android/.test(ua)) {
            return 'android';
        } else if (/iphone|ipad|ipod/.test(ua)) {
            return 'ios';
        } else {
            return 'pc';
        }
    }

    getNewGameUIIcon(iconName) {
        return new URL(`../../assets/icons/newgames/${HNewGameUIConfig.newGameUISuffix}/${iconName}`, import.meta.url).href
    }

    getRandomString(length, lowerCaseOnly = false) {
        const random = Math.random;
        const result = Array.from({length}, () =>
            charset[Math.floor(random() * charset.length)]
        ).join('');

        return lowerCaseOnly ? result.toLowerCase() : result;
    }

    getShowNamePhoneId(user){
        // 统一最多展示 6 个字符, 超出截断 + "..." (与 moregame Flutter / hsxs_flutter 对齐)
        const cap6 = (s) => s.length > 6 ? `${s.slice(0, 6)}...` : s;
        if(user.userName!==""){
            return cap6(user.userName);
        }
        if(user.phoneNumber!==""){
            // 手机号保留 mask 格式 (4 + *** + 4), 是公认的脱敏样式, 不参与 6 字符限制
            return user.phoneNumber.slice(0,4)+"***"+user.phoneNumber.slice(user.phoneNumber.length-4,user.phoneNumber.length);
        }
        if(user.userId!==""){
            // 保留完整 userId (含 channel 前缀), 截前 6 字符 + "..."
            return cap6(user.userId);
        }
        return "";
    }
}

export const hcf = new HComFunctions();
